/**
 * Client-side clue rendering utility
 * Renders clue templates by replacing slot placeholders with selected words
 */

import type { Clue } from '@blather/shared';

/**
 * Render a clue by replacing slot placeholders with selected words
 * Example: "It is [determiner] [adjective] [noun]" with slots ["a", "big", "house"]
 * becomes "It is a big house"
 */
export function renderClue(clue: Clue): string {
  let rendered = clue.template;

  // Process each slot in order
  clue.slots.forEach((slot) => {
    const placeholder = `[${slot.slotType}]`;
    const words = slot.selectedWords.join(' ');

    // Replace first occurrence of this placeholder
    rendered = rendered.replace(placeholder, words);
  });

  return rendered;
}
